export const UPLOAD_FILE_AVATAR = '/file/avartar/uploads'
export const UPLOAD_FILE_ONE = '/v1/images/upload'
export const UPLOAD_FILE_MULTIPLE = '/v1/images/uploads'

export const SAVE_FILE_ONE = '/v1/ecm-upload/create'
export const SAVE_FILE_LIST = '/v1/ecm-upload/list'
export const ECM_DELETE = '/v1/ecm-upload/delete/'